/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ScheduleControllerDeleteRepeatV1$Params {
  id: string;
  repeatUpdateType: 'THIS' | 'THIS_AND_FUTURE' | 'ALL';
}

export function scheduleControllerDeleteRepeatV1(http: HttpClient, rootUrl: string, params: ScheduleControllerDeleteRepeatV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, scheduleControllerDeleteRepeatV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('repeatUpdateType', params.repeatUpdateType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

scheduleControllerDeleteRepeatV1.PATH = '/api/v1/schedule/repeat/{id}';
